<div class="admin">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboarad">
                Inicio
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <h1 class="txt txt--title">Registrar infracción</h1>
        <small>A través del siguiente formulario podrás ingresar una sanción asociada a la licencia de un
          conductor.</small>
      </div>
      <app-form-select-person (resetForm)="onResetForm()" [controlForm]="formGroupPerson" class="global-full-width">
      </app-form-select-person>
      <div *ngIf="formGroupPerson.valid" class="global-full-width">
        <div class="container">
          <div class="">
            <app-form-location-and-equipment [controlForm]="formGroupLocationAndEquipment">
            </app-form-location-and-equipment>
            <div [ngClass]="!formGroupLocationAndEquipment.valid ? 'u-lock' : ''">
              <app-form-detail (emmitSeverityName)="onChangeSeverity($event)"
                (emmitInfrigmentTypeName)="onChangeInfringement($event)" [controlForm]="formGroupDetail"
                [assetId]="assetId"></app-form-detail>
            </div>
          </div>
          <div class="u-mt50" [ngClass]="formGroupDetail.valid && recommendation ? '' : 'u-lock'">
            <app-form-type-sanction [infrigementName]="infrigementName" [severityName]="severityName"
              [recommendation]="recommendation" [assetId]="assetId" [controlForm]="formGroupSanctionType"
              class="global-full-width">
            </app-form-type-sanction>
            <div class="request__send u-bt u-bt--grey u-pt20 u-mt20 u-mb20">
              <div class="buttons u-mt20">
                <div class="row">
                  <div class="col-md-3 order-md-1 order-2">
                    <a class="btn btn--link" (click)="onCancel()">Cancelar registro</a>
                  </div>
                  <div class="col-md-9 order-md-2 order-1">
                    <button type="button" class="btn btn--primary modal__trigger" data-modal="modal02"
                      [disabled]="form.valid ? null : true" (click)="onSubmit()">Registrar
                      infracción</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
